import { gql } from '@apollo/client';

export const DUPLICATE_INTERVENTION = gql`
  mutation duplicateIntervention($input: DuplicateInterventionInput!) {
    intervention: duplicateIntervention(input: $input) {
      id
      name
    }
  }
`;
